export const bonus = {
  bonus: {
    bonus: 'Bonus',
    bonusEngine: 'Bonus Engine',
    bonusProgram: 'Bonus Program',
    bonusTypes: {
      BETSOFT_CASINO: 'Betsoft Casino',
      CASINO_STANDARD: 'Casino Standard',
      SPORTS_STANDARD: 'Sports Standard',
      FREE_PLAY: 'Free Plays',
      FREE_SPINS: 'Free Spins',
    },
    bonusTriggerTypes: {
      DEPOSIT_BY_CODE: 'Deposit - By Code',
      DEPOSIT_BY_CLICK: 'Deposit - By Click',
      GAMIFICATION: 'By Gamification',
      MANUAL: 'By Manual',
      DEPOSIT: 'By Deposit',
      BY_BUNDLE: 'By Bundle',
      BY_CODE: 'By Code',
      BY_REGISTRATION: 'By Registration',
    },
  },
};
